/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectFlip, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-flip'
import { Image, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function DoubleRotateVerticalPreview({ srcs = [], redirectUrl }) {
  const [validImages, setValidImages] = useState([])
  const [swiperInstance, setSwiperInstance] = useState(null)
  const [flipDirection, setFlipDirection] = useState(1)
  const swiperRef = useRef(null)
  const scrollerRef = useRef(null)

  useEffect(() => {
    if (!Array.isArray(srcs) || srcs.length === 0) return

    setValidImages((prevImages) => {
      const filteredImages = srcs.filter(
        (src) =>
          src.file instanceof Blob ||
          src.file instanceof File ||
          (typeof src.file === 'string' && src.file.startsWith('blob:'))
      )

      if (JSON.stringify(filteredImages) === JSON.stringify(prevImages)) {
        return prevImages
      }

      return filteredImages.length === 1
        ? [...filteredImages, ...filteredImages]
        : filteredImages
    })
  }, [srcs])

  useEffect(() => {
    if (!scrollerRef.current) return

    let lastScrollY = 0

    const handleScroll = () => {
      if (!swiperInstance) return

      const scrollY = scrollerRef.current.scrollTop

      if (Math.abs(scrollY - lastScrollY) >= 5) {
        if (scrollY > lastScrollY) {
          setFlipDirection(1)
          swiperInstance.slideNext()
        } else {
          setFlipDirection(-1)
          swiperInstance.slidePrev()
        }

        document.documentElement.style.setProperty(
          '--flip-direction',
          flipDirection
        )

        swiperInstance.update()
        lastScrollY = scrollY
      }
    }

    scrollerRef.current.addEventListener('scroll', handleScroll)

    return () => {
      scrollerRef.current?.removeEventListener('scroll', handleScroll)
    }
  }, [swiperInstance, flipDirection])

  return (
    <div
      ref={scrollerRef}
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflowY: 'auto', overflowX: 'hidden' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      <div
        role="presentation"
        style={{ position: 'absolute', bottom: '20%', width: '240px' }}
        onClick={() => {
          if (redirectUrl) window.open(redirectUrl, '_blank')
        }}
      >
        <Swiper
          ref={swiperRef}
          effect="flip"
          grabCursor
          loop
          speed={1200}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[EffectFlip, Autoplay]}
          className="pt-2 pb-3 vertical-flip-swiper"
          style={{
            overflow: 'visible',
          }}
          onSwiper={(swiper) => {
            setSwiperInstance(swiper)
          }}
        >
          {validImages.map((src, idx) => (
            <SwiperSlide key={idx}>
              <div
                className="flip-card"
                style={{
                  width: '240px',
                  height: 'auto',
                }}
              >
                <Button
                  className="position-absolute"
                  style={{
                    top: '5px',
                    right: '5px',
                    width: '25px',
                    zIndex: 10,
                    background: 'rgba(0, 0, 0, 0.5)',
                    border: 'none',
                    padding: '0',
                    borderRadius: '50%',
                  }}
                >
                  ✕
                </Button>
                <img
                  className="flip-card-front"
                  src={
                    src.file
                      ? typeof src.file === 'string'
                        ? src.file
                        : URL.createObjectURL(src.file)
                      : ''
                  }
                  alt={src.label || 'Image'}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <CIIcon bottom="3%" right="18.75%" />
    </div>
  )
}

DoubleRotateVerticalPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
      label: PropTypes.string,
    })
  ),
  redirectUrl: PropTypes.string,
}

DoubleRotateVerticalPreview.defaultProps = {
  srcs: [],
  redirectUrl: [],
}

export default DoubleRotateVerticalPreview
